import { Category } from "./types/category";

export enum Taxonomy {
    income = "income",
    interest_income = "interest_income",
    other_income = "other_income",
    advertising_marketing = "advertising_marketing",
    auto_vehicle = "auto_vehicle",
    auto_insurance = "auto_insurance",
    auto_payment = "auto_payment",
    parking_tolls = "parking_tolls",
    communications = "communications",
    learning_development = "learning_development",
    entertainment = "entertainment",
    fees = "fees",
    merchant_bank_fees = "merchant_bank_fees",
    licenses_permits = "licenses_permits",
    penalties_fines = "penalties_fines",
    insurance = "insurance",
    health_insurance = "health_insurance",
    life_insurance = "life_insurance",
    legal_professional = "legal_professional",
    meals = "meals",
    payroll = "payroll",
    contractors = "contractors",
    salaries_wages = "salaries_wages",
    payroll_taxes = "payroll_taxes",
    rentals_leases = "rentals_leases",
    repairs_maintenance = "repairs_maintenance",
    software_subscriptions = "software_subscriptions",
    taxes = "taxes",
    federal_taxes = "federal_taxes",
    local_taxes = "local_taxes",
    property_taxes = "property_taxes",
    sales_taxes = "sales_taxes",
    travel = "travel",
    utilities = "utilities",
    supplies_equipment = "supplies_equipment",
    office_postage = "office_postage",
    furniture_fixtures = "furniture_fixtures",
    props_production = "props_production",
    credit_card_loans = "credit_card_loans",
    credit_card_payment = "credit_card_payment",
    interest_paid = "interest_paid",
    loan_payments_proceeds = "loan_payments_proceeds",
    transfer = "transfer",
    contributions_distributions = "contributions_distributions",
    improvements = "improvements",
    property_insurance = "property_insurance",
    management_fees = "management_fees",
    health_dental = "health_dental",
    donations = "donations",
    uncategorized = "uncategorized",
    retirement = "retirement",
    personal = "personal",
    home_office = "home_office",
    security_deposit = "security_deposit",
    principal_paid = "principal_paid",
    cogs = "cogs",
    direct_labor = "direct_labor",
    goods_materials = "goods_materials",
    other_cogs = "other_cogs",
    business_office = "business_office",
    mortgage_payment = "mortgage_payment",
    equipment_rentals = "equipment_rentals",
    investment = "investment",
    dividend_income = "dividend_income",
    client_gifts = "client_gifts",
    employee_benefits = "employee_benefits",
    retirement_benefits = "retirement_benefits",
    line_of_credit = "line_of_credit",
    escrow = "escrow",
    loan_fees = "loan_fees",
    charitable_contributions = "charitable_contributions",

    assets = "assets",
    computers = "computers",
    furniture = "furniture",
    machinery_equipment = "machinery_equipment",
    vehicles = "vehicles",
    buildings = "buildings",
    land = "land",
}

export enum TransactionDirectionType {
    incoming = "incoming",
    outgoing = "outgoing",
    mixed = "mixed",
}

interface MapCategoryNameParams {
    category: Pick<
        Category,
        "id" | "label" | "taxonomy" | "parentCategoryId" | "workspaceId"
    >;
    transactionDirection: TransactionDirectionType;
}

export const SPLIT_TAXONOMY_BY_DIRECTION = [
    Taxonomy.contributions_distributions,
    Taxonomy.loan_payments_proceeds,
    Taxonomy.line_of_credit,
];

export const mapCategoryName: (params: MapCategoryNameParams) => string = ({
    category,
    transactionDirection,
}) => {
    if (
        category.taxonomy === Taxonomy.contributions_distributions &&
        !category.parentCategoryId
    ) {
        if (transactionDirection === TransactionDirectionType.incoming) {
            return "Contributions";
        }
        if (transactionDirection === TransactionDirectionType.outgoing) {
            return "Distributions";
        }
    }

    if (
        category.taxonomy === Taxonomy.loan_payments_proceeds &&
        !category.workspaceId // We only want to modify the name for the global Loan Proceeds & Payments category, not custom categories
    ) {
        if (transactionDirection === TransactionDirectionType.incoming) {
            return "Loan Proceeds";
        }
        if (transactionDirection === TransactionDirectionType.outgoing) {
            return "Loan Payments";
        }
    }

    if (
        category.taxonomy === Taxonomy.line_of_credit &&
        !category.workspaceId // We only want to modify the name for the global Line of Credit category, not custom categories
    ) {
        if (transactionDirection === TransactionDirectionType.incoming) {
            return "Line of Credit Draws";
        }
        if (transactionDirection === TransactionDirectionType.outgoing) {
            return "Line of Credit Payments";
        }
    }

    return category.label;
};

export type TaxonomyMainCategories = Extract<
    Taxonomy,
    | Taxonomy.income
    | Taxonomy.uncategorized
    | Taxonomy.auto_vehicle
    | Taxonomy.repairs_maintenance
    | Taxonomy.donations
    | Taxonomy.insurance
    | Taxonomy.travel
    | Taxonomy.transfer
    | Taxonomy.contributions_distributions
    | Taxonomy.legal_professional
    | Taxonomy.supplies_equipment
    | Taxonomy.health_dental
    | Taxonomy.entertainment
    | Taxonomy.software_subscriptions
    | Taxonomy.advertising_marketing
    | Taxonomy.taxes
    | Taxonomy.credit_card_loans
    | Taxonomy.meals
    | Taxonomy.fees
    | Taxonomy.rentals_leases
    | Taxonomy.utilities
    | Taxonomy.communications
    | Taxonomy.retirement
    | Taxonomy.payroll
    | Taxonomy.learning_development
    | Taxonomy.personal
    | Taxonomy.security_deposit
    | Taxonomy.cogs
    | Taxonomy.business_office
    | Taxonomy.charitable_contributions
    | Taxonomy.assets
>;
